
export const GET_PRODUCTS_SUCCESS='GET_PRODUCTS_SUCCESS';
export const GET_PRODUCTS_REQUEST='GET_PRODUCTS_REQUEST';
export const GET_PRODUCTS_FAILURE='GET_PRODUCTS_FAILURE';

export const GET_ALL_PRODUCTS_SUCCESS='GET_ALL_PRODUCTS_SUCCESS';
export const GET_ALL_PRODUCTS_REQUEST='GET_ALL_PRODUCTS_REQUEST';
export const GET_ALL_PRODUCTS_FAILURE='GET_ALL_PRODUCTS_FAILURE';

export const APPROVED_PRODUCT_SUCCESS='APPROVED_PRODUCT_SUCCESS';
export const APPROVED_PRODUCT_REQUEST='APPROVED_PRODUCT_REQUEST';
export const APPROVED_PRODUCT_FAILURE = 'APPROVED_PRODUCT_FAILURE';

export const CREATE_PRODUCT_SUCCESS='CREATE_PRODUCT_SUCCESS';
export const CREATE_PRODUCT_REQUEST='CREATE_PRODUCT_REQUEST';
export const CREATE_PRODUCT_FAILURE = 'CREATE_PRODUCT_FAILURE';

export const UPDATE_PRODUCT_REQUEST = "UPDATE_PRODUCT_REQUEST";
export const UPDATE_PRODUCT_FAILURE = "UPDATE_PRODUCT_FAILURE";
export const UPDATE_PRODUCT_SUCCESS = "UPDATE_PRODUCT_SUCCESS";

export const REJECT_PRODUCT_SUCCESS='REJECT_PRODUCT_SUCCESS';
export const REJECT_PRODUCT_REQUEST='REJECT_PRODUCT_REQUEST';
export const REJECT_PRODUCT_FAILURE='REJECT_PRODUCT_FAILURE';

export const DELETE_PRODUCT_SUCCESS='DELETE_PRODUCT_SUCCESS';
export const DELETE_PRODUCT_REQUEST='DELETE_PRODUCT_REQUEST';
export const DELETE_PRODUCT_FAILURE='DELETE_PRODUCT_FAILURE';

